<template>
  <div
    class="dialog-wrapper"
    :style="wrapperStyle"
    @touchmove.stop.prevent
  >
    <transition name="fade">
      <div
        v-show="show"
        class="dialog-mask"
        @click.stop="_closeDialog"
      />
    </transition>
    <transition name="zoom">
      <div v-show="show" class="dialog">
        <div class="dialog-hd">
          {{ title }}
        </div>
        <div class="dialog-bd">
          <div class="dialog-inner" @touchmove.stop>
            <slot />
          </div>
        </div>
        <div class="dialog-fd">
          <a
            v-if="link"
            class="more after-bd-r"
            :href="link"
          >查看完整版</a>
          <a
            class="close"
            href="javascript:;"
            @click.stop="_closeDialog"
          >关闭</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { ANIMATION_TIME } from 'base/config'
  import {
    addClass,
    removeClass
  } from 'common/js/dom'

  // 层级
  const TOP_ZINDEX = 1000
  const BOTTOM_ZINDEX = -1
  // 滑动fix
  const NOSCROLL_CLASS = 'noscroll'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      link: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        show: false,
        layer: false
      }
    },
    computed: {
      wrapperStyle() {
        let retStyle = {}
        if (!this.layer) {
          retStyle.zIndex = BOTTOM_ZINDEX
        } else {
          retStyle.zIndex = TOP_ZINDEX
        }
        return retStyle
      }
    },
    watch: {
      visible (newData, oldData) {
        if (newData) {
          this._toggle(true)
        } else {
          this._closeDialog()
        }
      }
    },
    methods: {
      _closeDialog() {
        this._toggle()
        this.$emit('close')
      },
      _toggle(show) {
        let html = document.getElementsByTagName('html')[0]
        this.show = show
        if (show) {
          addClass(html, NOSCROLL_CLASS)
          this.layer = true
        } else {
          removeClass(html, NOSCROLL_CLASS)
          setTimeout(() => {
            this.layer = false
          }, ANIMATION_TIME)
        }
      }
    }
  }
</script>

<style>
  @import 'variable';

  .noscroll,
  .noscroll body {
    overflow: hidden;
  }
  .noscroll body {
    position: relative;
  }

  .dialog-wrapper {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    overflow: auto;

    .dialog-mask {
      width: 100%;
      height: 100%;
      background: var(--mask-color);
    }
    .dialog {
      z-index: 1001;
      position: absolute;
      top: 10%;
      left: 3%;
      border-radius: 4px;
      width: 94%;
      height: 80%;
      margin: 0 auto;
      background-color: var(--white-color);
      color: var(--thre-color);
    }
    .dialog-hd {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
    }
    .dialog-bd {
      overflow: hidden;
      padding-top: 40px;
      padding-bottom: 50px;
      height: 100%;
    }
    .dialog-fd {
      z-index: 1;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 50px;
      line-height: 50px;
      display: flex;
      >a {
        width: 50%;
        flex: 1;
        display: block;
        text-align: center;
        color: var(--hover-color);
      }
      &:before {
        content: '';
        pointer-events: none;
        position: absolute;
        background: #e5e5e5;
        transform-origin: 0 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px; /*no*/
        transform: scaleY(.5);
      }
    }
  }

  .zoom-enter-active {
    animation: zoomIn 0.5s;
  }

  .zoom-leave-active {
    animation: zoomOut 0.5s;
  }

  .fade-enter-active {
    animation: fadeIn 0.5s;
  }

  .fade-leave-active {
    animation: fadeOut 0.5s;
  }
</style>